module.exports = __webpack_public_path__ + "img/ve.9f23d962.svg";